/*
 * SPDX-FileCopyrightText: © 2025 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: block;
}

:host(:focus-visible) {
  outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
  border-radius: var(--qds-focus-border-radius);
}

.qds-disabled {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

.qds-icon {
  flex-shrink: 0;
}

.qds-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

[aria-disabled='true'] {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

.qds-action-item {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  border: none;
  cursor: pointer;
  border-radius: var(--qds-control-border-radius);

  &:hover {
    background-color: var(--qds-theme-interactive-background-hover);
  }

  &:active {
    background-color: var(--qds-theme-interactive-background-pressed);
  }
}

[data-size='small'] {
  &.qds-action-item {
    gap: var(--qds-list-item-small-gap-internal);
    min-height: var(--qds-list-item-small-height);
    padding-inline: var(--qds-list-item-small-padding-horizontal);
  }

  .qds-icon {
    height: var(--qds-control-small-icon-size);
    width: var(--qds-control-small-icon-size);
  }

  .qds-text {
    font: var(--qds-list-item-small-title);
  }
}

[data-size='standard'] {
  &.qds-action-item {
    gap: var(--qds-list-item-standard-gap-internal);
    min-height: var(--qds-list-item-standard-height);
    padding-inline: var(--qds-list-item-standard-padding-horizontal);
  }

  .qds-icon {
    height: var(--qds-control-standard-icon-size);
    width: var(--qds-control-standard-icon-size);
  }

  .qds-text {
    font: var(--qds-list-item-standard-title);
  }
}

[data-size='large'] {
  &.qds-action-item {
    gap: var(--qds-list-item-large-gap-internal);
    min-height: var(--qds-list-item-large-height);
    padding-inline: var(--qds-list-item-large-padding-horizontal);
  }

  .qds-icon {
    height: var(--qds-control-large-icon-size);
    width: var(--qds-control-large-icon-size);
  }

  .qds-text {
    font: var(--qds-list-item-large-title);
  }
}

[data-importance='standard'] {
  .qds-text {
    color: var(--qds-theme-text-standard);
  }

  .qds-icon {
    color: var(--qds-theme-control-text-standard);
  }
}

[data-importance='emphasized'] {
  &.qds-action-item {
    .qds-text,
    .qds-icon {
      color: var(--qds-theme-signature-color-default);
    }

    &:hover {
      .qds-text,
      .qds-icon {
        color: var(--qds-theme-signature-color-hover);
      }
    }

    &:active {
      .qds-text,
      .qds-icon {
        color: var(--qds-theme-signature-color-pressed);
      }
    }
  }
}

[data-importance='subdued'] {
  &.qds-action-item {
    .qds-text,
    .qds-icon {
      color: var(--qds-theme-link-standard-default);
    }

    &:hover {
      .qds-text,
      .qds-icon {
        color: var(--qds-theme-link-standard-hover);
      }
    }

    &:active {
      .qds-text,
      .qds-icon {
        color: var(--qds-theme-link-standard-pressed);
      }
    }
  }
}

[data-importance='destructive'] {
  &.qds-action-item {
    .qds-text,
    .qds-icon {
      color: var(--qds-theme-feedback-action-destructive-default);
    }

    &:hover {
      .qds-text,
      .qds-icon {
        color: var(--qds-theme-feedback-action-destructive-hover);
      }
    }

    &:active {
      .qds-text,
      .qds-icon {
        color: var(--qds-theme-feedback-action-destructive-pressed);
      }
    }
  }
}
